import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Department, Team, User } from '@masar/common/models';

@Component({
    selector: 'app-assigned-entity',
    template: `
        @if (item) {
            <!-- Assigned Departments -->
            @if (item.assignedDepartment) {
                @if (isArray(item.assignedDepartment)) {
                    @for (
                        department of item.assignedDepartment;
                        track department
                    ) {
                        <div>
                            <app-department-link
                                [item]="department"
                            ></app-department-link>
                        </div>
                    }
                } @else {
                    <app-department-link
                        [item]="item.assignedDepartment"
                    ></app-department-link>
                }
            }
            <!-- Assigned Teams -->
            @if (item.assignedTeam) {
                @if (isArray(item.assignedTeam)) {
                    @for (team of item.assignedTeam; track team) {
                        <div>
                            <app-team-link [item]="team"></app-team-link>
                        </div>
                    }
                } @else {
                    <app-team-link [item]="item.assignedTeam"></app-team-link>
                }
            }
            <!-- Assigned Users -->
            @if (item.assignedUser) {
                @if (isArray(item.assignedUser)) {
                    @for (user of item.assignedUser; track user) {
                        <div>
                            <span>{{ user.name }}</span>
                        </div>
                    }
                } @else {
                    <span>{{ item.assignedUser['name'] }}</span>
                }
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AssignedEntityComponent {
    @Input() public item: {
        assignedDepartment: Department | Department[];
        assignedTeam: Team | Team[];
        assignedUser: User | User[];
    };

    public isArray(value: any): boolean {
        return Array.isArray(value);
    }
}
